var map = {
	"./v2-home-certificates.svg": 5484,
	"./v2-home-channels.svg": 5485,
	"./v2-home-clp.svg": 5486,
	"./v2-home-courses.svg": 5487,
	"./v2-home-exams.svg": 5488,
	"./v2-home-gamification.svg": 5489,
	"./v2-home-leaderboard.svg": 5490,
	"./v2-home-projects.svg": 5491,
	"./v2-home-resume.svg": 5492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5483;